// Re-factored Header / Navigation
const MIN_STICKY_DISTANCE = 800;
const TRANSITION_DURATION = 250;
const mobileTrigger = document.querySelector("[data-mobile-trigger]");
const navPanelCheckboxes = document.querySelectorAll(".navigation__panel input");
const mobileNavSearch = document.querySelector(".navigation__panel .navigation__search input");
const desktopSearchModal = document.querySelector(".header__search");
const desktopSearchModalContent = desktopSearchModal.querySelector(".header__search-modal-content");
const headerSearch = document.querySelector("[data-header-search]");
const headerNav = document.querySelector(".header__navigation");
const mediaQuery990plus = window.matchMedia("(min-width: 990px)");

mobileTrigger.addEventListener("click", (evt) => {
  evt.preventDefault();
  evt.stopPropagation();
  if (document.body.classList.contains("nav-open")) {
    document.body.classList.remove("nav-open");
    navPanelCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  } else {
    document.body.classList.add("nav-open");
  }
});

const isClickedOutside = (event, element) => {
  const elementDimensions = element.getBoundingClientRect();
  const isClickOutside = !(
    event.clientX > elementDimensions.left &&
    event.clientX < elementDimensions.right &&
    event.clientY > elementDimensions.top &&
    event.clientY < elementDimensions.bottom
  );

  return isClickOutside;
};

const closeDesktopSearchModal = () => {
  document.body.classList.remove("search-open");
  document.body.classList.remove("overflow-hidden");
  desktopSearchModal.removeAttribute("open");
  document.body.removeEventListener("click", handleDesktopSearchModal);
};

const openDesktopSearchModal = () => {
  document.body.classList.add("search-open");
  document.body.classList.add("overflow-hidden");
  desktopSearchModal.setAttribute("open", "");
  desktopSearchModal.querySelector("input").focus();
  document.body.addEventListener("click", handleDesktopSearchModal);
};

const handleDesktopSearchModal = (evt) => {
  if (isClickedOutside(evt, desktopSearchModalContent)) {
    closeDesktopSearchModal();
  }
};

const toggleSearchModal = () => {
  if (document.body.classList.contains("search-open")) {
    closeDesktopSearchModal();
  } else {
    openDesktopSearchModal();
  }
};

headerSearch.addEventListener("click", (evt) => {
  // on mobile, open nav and focus search
  if (!mediaQuery990plus.matches) {
    evt.preventDefault();
    evt.stopPropagation();
    document.body.classList.add("nav-open");
    mobileNavSearch.focus();
  } else {
    if (!isClickedOutside(evt, headerSearch)) {
      evt.preventDefault();
      evt.stopPropagation();
      toggleSearchModal();
    }
  }
});

const htmlEl = document.documentElement;

class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = document.getElementById("shopify-section-header");
    this.header.classList.add("shopify-section-sticky-header");
    document.body.style.setProperty("--header-height", `${this.header.offsetHeight}px`);
  }
}
customElements.define("sticky-header", StickyHeader);

let isWaiting = false;
let animationFrameId = null;

const stickyHeaderEl = document.querySelector(".shopify-section-sticky-header");

const updateHeaderPosition = () => {
  if (!stickyHeaderEl) {
    console.warn("no sticky header found");
    return;
  }

  const isMenuOpen = document.body.classList.contains("nav-open");
  const isSearchOpen = document.body.classList.contains("search-open");

  if (isMenuOpen || isSearchOpen || isWaiting) {
    animationFrameId = requestAnimationFrame(updateHeaderPosition);
    return;
  }

  const top = window.scrollY;

  if (top > MIN_STICKY_DISTANCE) {
    if (!stickyHeaderEl.classList.contains("is-sticky")) {
      stickyHeaderEl.classList.add("no-transition");
      stickyHeaderEl.classList.add("is-sticky");
      isWaiting = true;

      setTimeout(function () {
        stickyHeaderEl.classList.remove("no-transition");
        stickyHeaderEl.classList.add("is-in-view");
        isWaiting = false;
      }, TRANSITION_DURATION);
    }
  } else {
    if (stickyHeaderEl.classList.contains("is-sticky")) {
      stickyHeaderEl.classList.remove("is-in-view");
      isWaiting = true;

      setTimeout(function () {
        stickyHeaderEl.classList.remove("is-sticky");
        isWaiting = false;
      }, TRANSITION_DURATION);
    }
  }

  animationFrameId = requestAnimationFrame(updateHeaderPosition);
};

const handleHeaderScroll = () => {
  if (animationFrameId) {
    cancelAnimationFrame(animationFrameId);
  }
  animationFrameId = requestAnimationFrame(updateHeaderPosition);
};

const deviceSupportsHover = window.matchMedia("(hover: hover)");

const topLevelTriggers = document.querySelectorAll(".navigation__item--lvl1");
const clearAllSubmenus = () => {
  topLevelTriggers.forEach((trigger) => {
    const submenu = trigger.querySelector(".navigation__submenu");
    if (submenu) submenu.classList.remove("is-visible");
  });
};

let megaMenuTouchController = new AbortController();
let megaMenuTouchControllerSignal = megaMenuTouchController.signal;

const handleMegaMenuTouchReveals = (signal) => {
  if (deviceSupportsHover.matches) return;

  topLevelTriggers.forEach((trigger) => {
    trigger.addEventListener(
      "click",
      (evt) => {
        clearAllSubmenus();

        if (trigger.classList.contains("navigation__item-with-children")) {
          if (evt.target.classList.contains("navigation__submenu-trigger")) {
            evt.preventDefault();
            evt.stopPropagation();
            const submenu = trigger.querySelector(".navigation__submenu");
            if (submenu) submenu.classList.toggle("is-visible");
          }
        }
      },
      { signal }
    );
  });

  // Clicking outside header should close submenus
  document.body.addEventListener(
    "click",
    (evt) => {
      if (isClickedOutside(evt, headerNav)) {
        clearAllSubmenus();
      }
    },
    { signal }
  );
};

let megaMenuTopLevelClicksController = new AbortController();
let megaMenuTopLevelClicksControllerSignal = megaMenuTopLevelClicksController.signal;

const handleMegaMenuTopLevelClicks = (signal) => {
  topLevelTriggers.forEach((trigger) => {
    trigger.addEventListener(
      "click",
      (evt) => {
        if (evt.target.classList.contains("navigation__submenu-trigger")) {
          const link = evt.target?.parentElement?.dataset?.link;
          if (link) {
            window.location.href = link;
          }
        }
      },
      { signal }
    );
  });
};

const handleDevices = (device) => {
  if (device === "mobile") {
    megaMenuTouchController.abort();
    megaMenuTopLevelClicksController.abort();
    window.addEventListener("scroll", handleHeaderScroll);
  } else {
    document.body.classList.remove("nav-open");
    navPanelCheckboxes.forEach((checkbox) => (checkbox.checked = false));
    cancelAnimationFrame(animationFrameId);
    window.removeEventListener("scroll", handleHeaderScroll);

    if (device === "tablet") {
      megaMenuTopLevelClicksController.abort();
      if (megaMenuTouchControllerSignal.aborted) {
        megaMenuTouchController = new AbortController();
        megaMenuTouchControllerSignal = megaMenuTouchController.signal;
      }
      handleMegaMenuTouchReveals(megaMenuTouchControllerSignal);
    } else {
      megaMenuTouchController.abort();
      if (megaMenuTopLevelClicksControllerSignal.aborted) {
        megaMenuTopLevelClicksController = new AbortController();
        megaMenuTopLevelClicksControllerSignal = megaMenuTopLevelClicksController.signal;
      }
      handleMegaMenuTopLevelClicks(megaMenuTopLevelClicksControllerSignal);
    }
  }
};

const initHeaderMenuLogic = () => {
  if (!mediaQuery990plus.matches) {
    handleDevices("mobile");
  } else {
    if (deviceSupportsHover.matches) {
      handleDevices("desktop");
    } else {
      handleDevices("tablet");
    }
  }
};

initHeaderMenuLogic();

deviceSupportsHover.addEventListener("change", () => {
  clearAllSubmenus();
  initHeaderMenuLogic();
});

mediaQuery990plus.addEventListener("change", () => {
  clearAllSubmenus();
  initHeaderMenuLogic();
});
